import React from 'react';
import { translate } from 'components/Translation';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import CustomCheckbox from 'components/CustomCheckbox/CustomCheckbox';
import CustomDatePicker from 'components/CustomDatePicker/CustomDatePicker';
import { isValidDate } from 'utils/date/validateDate';
import moment from 'moment';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDatePickerProps {
	date: any;
	setDate: (value: string) => void;
	isUnlimited: boolean;
	disabled?: boolean;
	isCalendarRight?: boolean;
	error?: boolean;
	errorText?: string;
	label?: string;
}

const DatePicker = ({
	date,
	setDate,
	isUnlimited,
	disabled,
	error,
	isCalendarRight,
	label,
	errorText,
}: IDatePickerProps) => {
	const classes = useStyles();

	return (
		<>
			<div className={classNames(classes.permissionCellAccess, classes.fullWidthForXs)}>
				<CustomDatePicker
					className={classNames({ [classes.calendar]: isCalendarRight })}
					timeFormat={false}
					value={isUnlimited ? '' : moment(date, 'YYYY-MM-DD')}
					dateFormat="DD.MM.YYYY"
					disabled={disabled}
					label={label}
					error={error}
					helperText={error ? errorText : ''}
					onChange={(value) => {
						if (moment.isMoment(value)) {
							setDate(value.format('YYYY-MM-DD'));
						}
					}}
					inputProps={{ disabled }}
					isValidDate={(currentDate) => isValidDate(currentDate, 'yesterday')}
				/>
			</div>
			<div
				className={classNames(
					classes.permissionCellAccess,
					classes.unlimitedCheckboxContainer,
					classes.fullWidthForXs,
					classes.left,
					{
						[classes.unlimitedWithLabel]: !!label,
					}
				)}
			>
				<CustomCheckbox
					label={translate('unlimited')}
					checked={isUnlimited}
					disabled={disabled}
					onClick={() => setDate('unlimited')}
					className={classNames({
						[classes.unlimitedCheckboxChecked]: isUnlimited,
						[classes.unlimitedCheckboxUnchecked]: !isUnlimited,
					})}
				/>
			</div>
		</>
	);
};

export default DatePicker;
